export function buildQuestionFormData({
     textAr,
     textEn,
     questionType,
     fullMark,
     examId,
     correctAnswer,
}) {
     const formData = new FormData();

     formData.append('text_en', textEn);
     formData.append('text_ar', textAr);
     formData.append('type', questionType);
     formData.append('full_mark', fullMark);
     if (examId)
          formData.append('exam_id', examId);
     if (questionType === 'true_false' && correctAnswer !== undefined && correctAnswer !== null) {
          formData.append('correct_answer', correctAnswer ? '1' : '0');
     }

     return formData;
}